module.exports = __webpack_public_path__ + "media/images/illustrations/unit_sizes/box-3b57b14095ba2b3532f0cffa141b6784.svg";